import { render, staticRenderFns } from "./access-control-config-form.vue?vue&type=template&id=a9b5a124&scoped=true&"
import script from "./access-control-config-form.vue?vue&type=script&lang=ts&"
export * from "./access-control-config-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5a124",
  null
  
)

export default component.exports